/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trip_Error_Vehicle_Not_AvailableInputs */

const vi_trip_error_vehicle_not_available = /** @type {(inputs: Trip_Error_Vehicle_Not_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xe vừa được người khác chọn, chọn xe khác`)
};

/**

* @param {Trip_Error_Vehicle_Not_AvailableInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trip_error_vehicle_not_available = /** @type {((inputs?: Trip_Error_Vehicle_Not_AvailableInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trip_Error_Vehicle_Not_AvailableInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trip_error_vehicle_not_available(inputs)
});